// extracted by mini-css-extract-plugin
export var button = "contact-demo-module--button--ab6a3 Button-module--filledDark--da7b8 Button-module--buttonBase--a1a0f";
export var demoButton = "contact-demo-module--demoButton--61148";
export var headline = "contact-demo-module--headline--74d45 typography-module--responsiveTitle3--2bebc typography-module--responsiveTitle1Medium--1f97c";
export var mini = "contact-demo-module--mini--af473";
export var miniButton = "contact-demo-module--miniButton--f5eb2 Button-module--filledDark--da7b8 Button-module--buttonBase--a1a0f";
export var miniRoot = "contact-demo-module--miniRoot--f2cd5";
export var miniText = "contact-demo-module--miniText--783ae";
export var root = "contact-demo-module--root--20e1c";